var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmallCheck = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.69 2.122a.419.419 0 0 0-.591 0l-.594.595C8.644 4.58 7.189 6.16 5.51 7.887a.418.418 0 0 1-.57.028L3.412 6.623 2.77 6.08a.419.419 0 0 0-.59.05L1.1 7.408a.419.419 0 0 0 .049.59l.64.542 2.723 2.303.589.497c.166.14.412.13.566-.024l.546-.545c2.259-2.264 3.864-4.069 6.071-6.281l.593-.593a.419.419 0 0 0 0-.593L11.69 2.122Z"
})));
SvgSmallCheck.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmallCheck);
export default ForwardRef;